export default __webpack_public_path__ + "static/1-def20b5ebb53ac0eb2d289868d79a0b8.png";